import React from 'react'
import Top_heading from './component/Top_heading'
import Main_Heading from './services-component/Main_Heading'
import InnerIMG from './services-component/services-main/InnerIMG'
import Component_Heading from './component/Component_Heading'
import Inner_section1 from './services-component/services-main/Inner_section1'
import Inner_Section2 from './services-component/services-main/Inner_Section2'
import ContactArea from './services-component/ContactArea'

export default function InnerPage() {
  return (
    <>
      <Top_heading Heading="INNER PAGE" />
      <Main_Heading SideHeading="AWARD-WINNING 
DIGITAL MARKETING 
AGENCY DESIGNED 
TO DRIVE

"
ButtonText="Share Your Project"
para2="Digital Marketing Services that are aligned to your business' growth targets
By implementing a strategy-first approach, our team identifies the right approach aligned to 
the goals of your business. This process includes a full competitor audit together with an outline of the messaging, content and services required to achieve your business' growth targets."
para3="Our digital marketing strategies are designed to meet the customer where they are at in the 
buyer's journey and ultimately convert them into loyal customers and long standing brand advocates. This is done through smart and personalized digital marketing services, creative 
thinking and transformative technology, ensuring effective and measurable results."
para1="If your business has clear growth targets, partner with NEXA to achieve these.This is done 
through smart and personalized digital marketing services, creative thinking and transformative technology, ensuring effective and measurable results."
/>

<InnerIMG/>

<Component_Heading heading="INNER PAGE CONTENT SERVICES"/>
<Inner_section1/>
<Component_Heading heading="INNER PAGE CONTENT SERVICES" para="
Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim 
ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. "/>

<Inner_Section2/>
<ContactArea/>

</>
  )
}
